import React, {useContext, useEffect, useState} from 'react';
import Footer from '../../components/Footer/Footer';
import Navbar from '../../components/Navbars/Navbar2';
import './LandingPage.scss';
import {useNavigate} from 'react-router-dom';
import {UserContext} from '../../utils/UserContext';
import {getJobsBasedOnPreferences, getLikedJobs, likeJobApi, trackJobImpression} from '../../api/jobsApi';
import LoginMessage from '../../components/Popups/LoginMessage';
import {Helmet} from 'react-helmet';
import GoogleModal from '../../components/Popups/GoogleModal';
import {JobModal, SelectedJobCard} from './LandingPageCards';
import {ROUTES} from '../../utils/ROUTES';
import {Alert, useMediaQuery} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import {permColors} from '../../utils/colors';
import {COUNTRY_CODE} from '../../api/locationApi';
import {AutoComplete, Button, Empty, Spin, Tooltip, Segmented} from 'antd';
import {CloseCircleOutlined, DownOutlined, SearchOutlined, UnorderedListOutlined} from '@ant-design/icons';
import {JobCard} from './JobCard';
import {CustomPagination} from '../../utils/MaterialUiThemes';
import {COOKIES} from '../../utils/cookie-names';
import Cookies from 'js-cookie';
import {isJobSeeker, userExists} from '../../utils/variables/userVariables';
import {useAtom} from 'jotai';
import {jobsAtom, jobsAtomTriggered, likedJobsAtom, selectedJobAtom, totalJobsAtom, totalPagesAtom, currentJobsPageAtom, appliedJobRetriggerAtom, jobPreferenceChangedAtom} from '../../utils/atoms';
import {AutoAwesome, Bookmark, BookmarkBorder, TouchAppOutlined} from '@mui/icons-material';
import {clearSearchItem, getSearchHistory, saveSearch} from '../../utils/searchCookies';
import {isFilterOnAtom} from '../../utils/atoms/filterAtoms';
import {AiJobMatchCardAd} from '../../components/landing-page-items/landing-page-items';
import AiInfoModal from '../../components/landing-page-items/ai-info-modal';
import {Target, Zap, Globe, Sparkle} from 'lucide-react';
import AnimatedBackground from '../../components/Backgrounds/AnimatedBackground';

export default function LandingPage() {
	const [selected, setSelected] = useState(true);
	const [jobs, setJobs] = useAtom(jobsAtom);
	const [jobsTriggered, setJobsTriggered] = useAtom(jobsAtomTriggered);
	const [likedJobs, setLikedJobs] = useAtom(likedJobsAtom);
	const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom);
	const [selectedJob2, setSelectedJob2] = useState({});
	const [currentUser] = useContext(UserContext);
	const [localLikedJobs, setLocalLikedJobs] = useState([]);
	const [retrigger, setRetrigger] = useState(false);
	const navigate = useNavigate();
	const [currentPage, setCurrentPage] = useAtom(currentJobsPageAtom);
	const [message, setMessage] = useState('');
	const [popup, setPopup] = useState(false);
	const [search, setSearch] = useState('');
	const [googleModal, setGoogleModal] = useState(false);
	const [totalJobs, setTotalJobs] = useAtom(totalJobsAtom);
	const [totalPages, setTotalPages] = useAtom(totalPagesAtom);
	const [appliedJobTrigger, setAppliedJobTrigger] = useAtom(appliedJobRetriggerAtom);

	const [modalShow1, setModalShow1] = React.useState(false);
	const [modalShow2, setModalShow2] = React.useState(false);
	const [jobLoading, setJobLoading] = useState(false);
	const smallMatches = useMediaQuery('(max-width: 1350px)');

	const [snackbarOpen, setSnackbarOpen] = React.useState(false);
	const [snackbarMessage, setSnackbarMessage] = React.useState('');
	const [snackbarSeverity, setSnackbarSeverity] = React.useState('');

	const [searchHistory, setSearchHistory] = useState([]);
	const [activeTab, setActiveTab] = useState('List');
	const [isFilterOn, setIsFilterOn] = useAtom(isFilterOnAtom);
	const [jobPreferenceChanged, setJobPreferenceChanged] = useAtom(jobPreferenceChangedAtom);
	useEffect(() => {
		const history = getSearchHistory();
		if (history) {
			setSearchHistory(JSON.parse(history).reverse());
		}
	}, [setSearchHistory]);

	const onSearch = (value) => {
		const searchParams = new URLSearchParams();
		searchParams.append('search', value);
		saveSearch(value);
		navigate(`${ROUTES.BROWSE_JOBS}/?${searchParams.toString()}`);
	};

	useEffect(() => {
		if (smallMatches) return;

		// Only set initial selection if there isn't already a selected job
		if (jobs?.length > 0 && !selectedJob?.id) {
			setSelectedJob(jobs[0]);
			setModalShow1(true);
		}

		if (likedJobs?.length > 0 && !selectedJob2?.id) {
			setSelectedJob2(likedJobs[0]);
			setModalShow2(true);
		}
	}, [jobs]);

	async function fetchJobs() {
		setSelectedJob({});
		setJobLoading(true);
		// const data = await getJobs(currentPage);
		const data = await getJobsBasedOnPreferences(currentPage);
		console.log(data);
		setJobs(data?.results);
		setTotalJobs(data?.count);
		if (data?.results?.length > 0) {
			setSelectedJob(data.results[0]);

			const currentLocation = Cookies.get(COOKIES.current_location);
			if (currentLocation && currentLocation !== ROUTES.HOME) {
				console.log('Navigating to:', currentLocation);
				Cookies.remove(COOKIES.current_location);
				navigate(currentLocation);
			}

			if (Cookies.get(COOKIES.apply_job_redirect)) {
				const jobId = Cookies.get(COOKIES.apply_job_redirect);
				const selectedJob = data?.results?.find((job) => job.id === jobId);
				setSelectedJob(selectedJob);
				Cookies.remove(COOKIES.apply_job_redirect);
			}
		}
		if (data?.count === 0) {
			setSelectedJob({});
		}
		setTotalPages(data?.total_pages);
		setJobLoading(false);
		setJobsTriggered(true); // Set this to true after first fetch
		window.scrollTo({top: 0, behavior: 'smooth'});
	}

	const handleAppliedJobUpdate = async () => {
		if (appliedJobTrigger) {
			const currentSelectedJobId = selectedJob?.id;
			const currentPageNumber = currentPage;

			try {
				setSelectedJob({});

				const data = await getJobsBasedOnPreferences(currentPageNumber);
				setJobs(data?.results);
				setTotalJobs(data?.count);

				// Find the updated job after the new data is fetched
				const updatedJob = data?.results?.find((job) => job.id === currentSelectedJobId);

				// Use a small delay to ensure the jobs list has re-rendered
				setTimeout(() => {
					if (updatedJob) {
						setSelectedJob(updatedJob);
						const jobCard = document.getElementById(`job-card-${currentSelectedJobId}`);
						if (jobCard) {
							jobCard.scrollIntoView({behavior: 'smooth'});
						}
					}
				}, 300);

				setAppliedJobTrigger(false);
			} catch (error) {
				console.error('Error updating jobs:', error);
			}
		}
	};

	useEffect(() => {
		if (!jobsTriggered) {
			fetchJobs();
		}

		if (jobPreferenceChanged) {
			fetchJobs();
			setJobPreferenceChanged(false);
		}

		handleAppliedJobUpdate();

		if (isFilterOn) {
			setIsFilterOn(false);
			fetchJobs();
		}
	}, [currentUser, appliedJobTrigger]);

	async function fetchJobsOnPageChange(page) {
		setCurrentPage(page);
		const data = await getJobsBasedOnPreferences(page); // Pass the page parameter directly instead of using currentPage
		setJobs(data?.results);
		setTotalJobs(data?.count);
		setTotalPages(data?.total_pages);
		setJobLoading(false);
		window.scrollTo({top: 0, behavior: 'smooth'});
	}

	async function fetchLikedJobs() {
		if (!currentUser.id) return;

		const data = await getLikedJobs();
		setLikedJobs(data);
		const newLocalLikedJobs = [];

		data.forEach((job) => {
			job?.likes?.forEach((like) => {
				if (like === currentUser.id) {
					newLocalLikedJobs.push({userId: currentUser.id, jobId: job.id});
				}
			});
		});

		setLocalLikedJobs(newLocalLikedJobs);
	}

	useEffect(() => {
		if (currentUser.id) {
			fetchLikedJobs();
		}
	}, [retrigger, currentUser]);

	const setH1Text = () => {
		const countryCode = Cookies.get('countryCode');
		if (countryCode === COUNTRY_CODE.PHILIPPINES || isJobSeeker(currentUser)) {
			return 'Find remote jobs with employers worldwide';
		} else {
			return 'Hire talent from the Philippines direct';
		}
	};

	const setAiText = () => {
		const countryCode = Cookies.get('countryCode');
		return countryCode === COUNTRY_CODE.PHILIPPINES || isJobSeeker(currentUser) ? (
			'Use our CV parsing AI tool to update your profile with your latest CV!'
		) : (
			<span className="flex flex-col sm:flex-row items-start gap-2 ">
				AI-powered CV feedback providing candidate insights on your job post via email and Applicants Tracking page!
				<AiInfoModal buttonClassName="bg-white/10 text-white text-xs font-light hover:bg-white/20" buttonSize="small" />
			</span>
		);
	};

	function selectJob(job) {
		setSelectedJob(job);
		setModalShow1(true);

		trackJobImpression(job.id);
	}

	function selectJob2(job) {
		setSelectedJob2(job);
		setModalShow2(true);
	}

	function authenticatedButtons(jobSelection) {
		if (currentUser.id === jobSelection.created_by) {
			return;
		} else {
			const isJobLiked = localLikedJobs.find((job) => job.jobId === jobSelection.id && job.userId === currentUser.id);
			return isJobLiked ? (
				<Tooltip title="Saved">
					<Button icon={<Bookmark style={{color: permColors.charcoal}} className="text-base" />} onClick={() => heartClicked(jobSelection.id)} />
				</Tooltip>
			) : (
				<Tooltip title="Save job">
					<Button icon={<BookmarkBorder style={{color: permColors.charcoal}} className="text-base" />} onClick={() => heartClicked(jobSelection.id)} />
				</Tooltip>
			);
		}
	}

	const handleChange = (value) => {
		setActiveTab(value); // Update the tab key
		setSelected(value === 'List');

		if (value === 'List') {
			setSelectedJob2(likedJobs[0]);
		}
	};

	async function likeJob(id) {
		await likeJobApi(id);
		setRetrigger(!retrigger);
	}

	function closePopup() {
		setPopup(false);
	}

	function heartClicked(id) {
		if (!userExists(currentUser)) {
			setMessage('Please login to like a job');
			setGoogleModal(true);
			return;
		}
		const isJobLiked = localLikedJobs.find((job) => job.jobId === id && job.userId === currentUser.id);
		if (isJobLiked) {
			let filtered = localLikedJobs.filter((job) => job.jobId !== id);
			setLocalLikedJobs(filtered);
			if (!selected) {
				setSelectedJob2({});
			}
			if (selectedJob2.id === id) {
				setSelectedJob2({});
			}
			setSnackbarUnliked();
		} else {
			let newLikedJob = {
				userId: currentUser.id,
				jobId: id,
			};
			setLocalLikedJobs([...localLikedJobs, newLikedJob]);
			setSnackbarLiked();
		}
		likeJob(id);
	}

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setSnackbarOpen(false);
	};

	const setSnackbarLiked = () => {
		setSnackbarMessage('Job saved');
		setSnackbarSeverity('success');
		setSnackbarOpen(true);
	};

	const setSnackbarUnliked = () => {
		setSnackbarMessage('Job unsaved');
		setSnackbarSeverity('info');
		setSnackbarOpen(true);
	};

	useEffect(() => {
		console.log('selectedJob2: ');
	}, [selectedJob2]);

	return (
		<div className="landingPageContainer">
			<Helmet>
				<title>Permworks</title>
				<meta name="description" content="Explore new job opportunities on Permworks. Start your next career move with us." />
				<meta name="google-site-verification" content="2kKe4Wd2lwP2FcOIKXUuMI7dB-7bSF0tHDWZDzoLpew" />
				<meta name="canonical" content={`https://permworks.com/${ROUTES.HOME}`} />
			</Helmet>
			<div className="landingPage">
				<div className="relative w-full  overflow-hidden bg-gradient-to-br from-deepBlue via-navy to-darkBlue">
					{/* Animated Background Component */}
					<AnimatedBackground variant="hero" />

					{/* Navbar */}
					<div className="relative z-20">
						<Navbar darkMode={true} />
					</div>

					{/* Hero Content - Compact Layout */}
					<div className="relative z-10 flex items-center justify-center px-4 sm:px-6 py-4 sm:py-10">
						<div className="w-full max-w-[1260px] mx-auto">
							<div className="flex flex-col lg:flex-row items-center justify-start gap-10 lg:gap-14 p-2">
								{/* Left Column - Compact Typography */}
								<div className="flex-1 grow space-y-4 animate-slide-in-left w-full">
									{/* Compact Badge */}
									<div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1.5">
										<AutoAwesome className="text-white text-xs" />
										<span className="text-white text-xs font-medium tracking-wide">AI-Powered Platform</span>
									</div>

									{/* Compact Typography */}
									<h1 className="text-3xl lg:text-5xl font-light text-white leading-tight tracking-tight text-left">
										{setH1Text().split(' ').slice(0, -2).join(' ')}
										<span className="block text-linkBlue font-medium mt-1">{setH1Text().split(' ').slice(-2).join(' ')}</span>
									</h1>

									{/* Compact Description */}
									<div className="text-sm lg:text-base text-white/80 font-light leading-relaxed lg:max-w-xl">
										<p className="mb-2">
											{Cookies.get('countryCode') === COUNTRY_CODE.PHILIPPINES || isJobSeeker(currentUser)
												? 'Start applying for jobs and we will match you with opportunities that align with your skills and aspirations.'
												: 'Discover skilled Filipino professionals perfectly matched to your requirements.'}
										</p>
										<div className="text-xs lg:text-sm text-white/70">{setAiText()}</div>
									</div>

									{(Cookies.get('countryCode') === COUNTRY_CODE.PHILIPPINES || isJobSeeker(currentUser)) && (
										<div className="lg:hidden">
											<AutoComplete
												className="w-full text-base rounded-md min-h-[50px]"
												prefix={<SearchOutlined className="text-gray-500 mx-3 text-base" />}
												options={searchHistory?.map((search) => ({
													value: search,
													label: (
														<div className="flex justify-between items-center py-2">
															<span className="text-gray-700 font-medium text-sm">{search}</span>
															<CloseCircleOutlined
																onClick={(e) => {
																	e.stopPropagation();
																	clearSearchItem(search);
																	setSearchHistory(searchHistory.filter((item) => item !== search));
																}}
																className="text-gray-400 hover:text-gray-600"
															/>
														</div>
													),
												}))}
												placeholder="Job title, company, or keywords..."
												filterOption={(inputValue, option) => option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
												onSelect={onSearch}
												onSearch={(value) => setSearch(value)}
												onKeyDown={(e) => {
													if (e.key === 'Enter') {
														onSearch(e.target.value);
													}
												}}
												style={{
													backgroundColor: 'rgba(255, 255, 255, 0.95)',
													border: 'none',
													fontSize: '14px',
												}}
											/>
										</div>
									)}

									{/* Compact CTA Section */}
									<div className="flex flex-col sm:flex-row gap-3">
										{Cookies.get('countryCode') === COUNTRY_CODE.PHILIPPINES || isJobSeeker(currentUser) ? (
											<>
												<Button
													size="large"
													className="bg-antBlue hover:bg-antBlue/90 border-antBlue text-white font-semibold px-6 py-3  shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 hover:-translate-y-1 lg:flex hidden"
													onClick={() => navigate(ROUTES.BROWSE_JOBS)}>
													<span className="text-sm">Find Jobs</span>
												</Button>
												<Button
													size="large"
													className="bg-antBlue hover:bg-antBlue/90 border-antBlue text-white font-semibold px-6 py-3  shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 hover:-translate-y-1 lg:hidden"
													onClick={() => onSearch(search)}>
													<span className="text-sm">Find Jobs</span>
												</Button>
												<Button
													size="large"
													className="bg-white/10 hover:bg-white/20 border-white/30 hover:border-white/50 text-white font-semibold px-6 py-3  backdrop-blur-sm transition-all duration-300 hover:scale-105 hover:-translate-y-1"
													onClick={() => navigate(ROUTES.JOB_PREFERENCE)}>
													<span className="text-sm">Set Preferences</span>
												</Button>
											</>
										) : (
											<>
												<Button
													size="large"
													className="bg-antBlue hover:bg-antBlue/90 border-antBlue text-white font-semibold px-6 py-3  shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 hover:-translate-y-1"
													onClick={() => navigate(ROUTES.POST_JOB, {state: {from: 'employerLink'}})}>
													<span className="text-sm">Post a Job</span>
												</Button>
												<Button
													size="large"
													className="bg-white/10 hover:bg-white/20 border-white/30 hover:border-white/50 text-white font-semibold px-6 py-3  backdrop-blur-sm transition-all duration-300 hover:scale-105 hover:-translate-y-1"
													onClick={() => navigate(ROUTES.BROWSE_JOBS)}>
													<span className="text-sm">Browse Jobs</span>
												</Button>
											</>
										)}
									</div>
								</div>

								{/* Right Column - Compact Content Card */}
								<div className="w-full lg:col-span-5 flex-1 animate-slide-in-right hidden lg:flex justify-center items-center">
									{Cookies.get('countryCode') === COUNTRY_CODE.PHILIPPINES || isJobSeeker(currentUser) ? (
										// Compact Job Seeker Search Card
										<div className="bg-white/8 backdrop-blur-2xl border border-white/20 rounded-2xl p-6 max-w-[500px]  shadow-2xl hover:bg-white/10 transition-all duration-500">
											<div className="space-y-4">
												{/* Compact Card Header */}
												<div className="text-center space-y-1">
													<h3 className="text-xl font-light text-white">Find Your Next Role</h3>
													<p className="text-white/70 text-xs">Discover opportunities that match your skills</p>
												</div>

												{/* Compact Search Interface */}
												<div className="relative group">
													<AutoComplete
														className="w-full text-base rounded-md min-h-[50px]"
														prefix={<SearchOutlined className="text-gray-500 mx-3 text-base" />}
														options={searchHistory?.map((search) => ({
															value: search,
															label: (
																<div className="flex justify-between items-center py-2">
																	<span className="text-gray-700 font-medium text-sm">{search}</span>
																	<CloseCircleOutlined
																		onClick={(e) => {
																			e.stopPropagation();
																			clearSearchItem(search);
																			setSearchHistory(searchHistory.filter((item) => item !== search));
																		}}
																		className="text-gray-400 hover:text-gray-600"
																	/>
																</div>
															),
														}))}
														placeholder="Job title, company, or keywords..."
														filterOption={(inputValue, option) => option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
														onSelect={onSearch}
														onSearch={(value) => setSearch(value)}
														onKeyDown={(e) => {
															if (e.key === 'Enter') {
																onSearch(e.target.value);
															}
														}}
														style={{
															backgroundColor: 'rgba(255, 255, 255, 0.95)',
															border: 'none',
															fontSize: '14px',
														}}
													/>
												</div>

												{/* Compact Popular Tags */}
												<div className="space-y-2">
													<p className="text-white/60 text-xs uppercase tracking-wider font-semibold">Popular Searches</p>
													<div className="flex flex-wrap gap-1.5">
														{['Software Engineer', 'Marketing', 'Design', 'Customer Service'].map((tag) => (
															<button
																key={tag}
																onClick={() => onSearch(tag)}
																className="bg-white/10 hover:bg-antBlue/30 text-white/90 hover:text-white text-xs px-2.5 py-1 rounded-md transition-all duration-200 hover:scale-105 font-medium border border-white/20 hover:border-antBlue/40">
																{tag}
															</button>
														))}
													</div>
												</div>

												{/* Compact Stats */}
												<div className="grid grid-cols-2 gap-3 pt-3 border-t border-white/20">
													<div className="text-center">
														<div className="text-2xl font-light text-white mb-0.5">3k+</div>
														<div className="text-xs text-white/70 font-medium">Successful Placements</div>
													</div>
													<div className="text-center">
														<div className="text-2xl font-light text-white mb-0.5">500+</div>
														<div className="text-xs text-white/70 font-medium">Companies</div>
													</div>
												</div>
											</div>
										</div>
									) : (
										// Compact Employer Info Card
										<div className="bg-white/8 backdrop-blur-2xl border border-white/20 rounded-2xl p-6 max-w-[500px] shadow-2xl hover:bg-white/10 transition-all duration-500">
											<div className="space-y-4">
												{/* Compact Card Header */}
												<div className="text-center space-y-1">
													<h3 className="text-xl font-light text-white">Start Hiring Today</h3>
													<p className="text-white/70 text-xs">Post your job and connect with top Filipino talent</p>
												</div>

												{/* Compact Quick Post Job CTA */}
												<div className="space-y-2.5">
													<Button
														size="large"
														className="w-full bg-antBlue hover:bg-antBlue/90 border-antBlue text-white font-semibold py-3  shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
														onClick={() => navigate(ROUTES.POST_JOB, {state: {from: 'heroCard'}})}>
														<span className="text-sm">Post a Job</span>
													</Button>

													<Button
														size="large"
														className="w-full bg-white/10 hover:bg-white/20 border-white/30 hover:border-white/50 text-white font-semibold py-3  backdrop-blur-sm transition-all duration-300 hover:scale-105"
														onClick={() => navigate(ROUTES.BROWSE_JOBS)}>
														<span className="text-sm">Browse Posted Jobs</span>
													</Button>
												</div>

												{/* Compact Why Choose Us */}
												<div className="space-y-2">
													<p className="text-white/60 text-xs uppercase tracking-wider font-semibold">Why Choose Permworks</p>
													<div className="flex flex-col sm:grid sm:grid-cols-2 gap-2">
														{[
															{icon: <Target className="w-3.5 h-3.5 text-white/80" />, text: 'AI-powered candidate matching'},
															{icon: <Sparkle className="w-3.5 h-3.5 text-white/80" />, text: 'AI-powered CV feedback'},
															{icon: <Zap className="w-3.5 h-3.5 text-white/80" />, text: 'Fast hiring process'},
															{icon: <Globe className="w-3.5 h-3.5 text-white/80" />, text: 'Access to Philippines talent pool'},
														].map((feature, index) => (
															<div key={index} className="flex items-center gap-2.5 text-white/80">
																<div className="flex-shrink-0">{feature.icon}</div>
																<span className="text-xs font-medium">{feature.text}</span>
															</div>
														))}
													</div>
												</div>

												{/* Compact Employer Stats */}
												<div className="grid grid-cols-2 gap-3 pt-3 border-t border-white/20">
													<div className="text-center">
														<div className="text-2xl font-light text-white mb-0.5">2K+</div>
														<div className="text-xs text-white/70 font-medium">Successful Hires</div>
													</div>
													<div className="text-center">
														<div className="text-2xl font-light text-white mb-0.5">95%</div>
														<div className="text-xs text-white/70 font-medium">Satisfaction Rate</div>
													</div>
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>

					{/* Compact Scroll Button */}
					<div className="relative z-10 flex justify-center pb-4">
						<button
							onClick={() => {
								const jobsSection = document.querySelector('.secondContainer');
								if (jobsSection) {
									jobsSection.scrollIntoView({
										behavior: 'smooth',
										block: 'start',
									});
								}
							}}
							className="group cursor-pointer transition-all duration-300 hover:scale-110 rounded-full p-2"
							aria-label="Scroll to jobs section">
							<div className="flex flex-col items-center gap-1 animate-bounce group-hover:animate-none">
								<span className="text-white/50 group-hover:text-white/80 text-xs font-medium transition-colors duration-300">Scroll to explore jobs</span>
								<DownOutlined className="text-white/50 group-hover:text-white/80 text-xs font-medium transition-colors duration-300" />
							</div>
						</button>
					</div>
				</div>
				<div key="e" className="secondContainer ">
					<div className="title-container flex gap-2 justify-center items-center flex-wrap  max-w-[1260px] p-3" key="z">
						<Segmented
							value={activeTab}
							onChange={handleChange}
							options={[
								{
									label: (
										<span className="flex items-center gap-2 ">
											<UnorderedListOutlined />
											Jobs feed
										</span>
									),
									value: 'List',
								},
								{
									label: (
										<span className="flex items-center gap-2">
											<BookmarkBorder className="text-base" />
											Saved jobs
										</span>
									),
									value: 'Kanban',
								},
							]}
							className="shadow-border-no-background bg-backgroundGreyBlue p-1"
						/>
						{isJobSeeker(currentUser) && (
							<p className="text-sm text-charcoal flex items-center gap-2">
								Want a job feed tailored just for you?{' '}
								<Button size="small" onClick={() => navigate(ROUTES.JOB_PREFERENCE)} icon={<TouchAppOutlined className="text-base" />}>
									Set your preferences
								</Button>
							</p>
						)}
					</div>
					{selected && (
						<div className="feedContainer max-w-[1260px] mx-auto" key="g">
							{!jobLoading ? (
								<div className="allFeeds 2xl:inline-block" key="l">
									<AiJobMatchCardAd user={currentUser} country={Cookies.get('countryCode')} />
									{jobs?.length > 0 &&
										jobs?.map((job) => (
											<JobCard
												id={`job-card-${job?.id}`}
												key={job?.id}
												job={job}
												isSelected={job?.id === selectedJob?.id}
												onJobSelect={selectJob}
												authenticatedButtons={authenticatedButtons}
											/>
										))}
								</div>
							) : (
								<Spin className="mx-auto my-10" size="large" />
							)}

							{selectedJob?.title && !smallMatches && <SelectedJobCard job={selectedJob} onNavigate={navigate} authenticatedButtons={authenticatedButtons} />}
						</div>
					)}

					{selectedJob?.title && smallMatches && (
						<JobModal job={selectedJob} show={modalShow1} onHide={() => setModalShow1(false)} onNavigate={navigate} authenticatedButtons={authenticatedButtons} />
					)}

					{!selected && (
						<div className="feedContainer max-w-[1260px] mx-auto">
							<div className="allFeeds lg:inline-block">
								{likedJobs?.length > 0 ? (
									likedJobs?.map((job) => (
										<JobCard key={job?.id} job={job} isSelected={job?.id === selectedJob2?.id} onJobSelect={selectJob2} authenticatedButtons={authenticatedButtons} />
									))
								) : (
									<Empty
										description={
											<span>
												No saved jobs yet
												<br />
												<Button className="ml-2 mt-2" onClick={() => handleChange('List')}>
													Browse jobs
												</Button>
											</span>
										}
										image={Empty.PRESENTED_IMAGE_SIMPLE}
										className="my-8"
									/>
								)}
							</div>

							{selectedJob2?.title && !smallMatches && <SelectedJobCard job={selectedJob2} onNavigate={navigate} authenticatedButtons={authenticatedButtons} />}

							{selectedJob2?.title && smallMatches && (
								<JobModal job={selectedJob2} show={modalShow2} onHide={() => setModalShow2(false)} onNavigate={navigate} authenticatedButtons={authenticatedButtons} />
							)}
						</div>
					)}
				</div>
			</div>
			{totalJobs > 20 && selected && (
				<div className="pages mx-auto my-3">
					<CustomPagination disabled={jobLoading} count={totalPages} page={currentPage} onChange={(event, value) => fetchJobsOnPageChange(value)} />
				</div>
			)}
			<LoginMessage message={message} showPopup={popup} closePopup={closePopup} />
			<GoogleModal
				openGoogle={googleModal}
				dialogTitle="Login to Apply"
				dialogContent="You need to login to like to this job."
				button2="Login"
				closeGoogle={() => setGoogleModal(false)}
				button2function={() => navigate('/authenticate')}
				button1="Cancel"
				button1function={() => setGoogleModal(false)}
			/>
			<Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
				<Alert onClose={handleClose} severity={snackbarSeverity} sx={{width: '100%'}} variant="filled">
					{snackbarMessage}
				</Alert>
			</Snackbar>
			<Footer backgroundColor={permColors.backgroundGrey} />
		</div>
	);
}
